import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "src/styled";

const LogbookManager = () => {
  return (
    <PageContainer>
      <Breadcrumbs />
    </PageContainer>
  );
};

export default LogbookManager;
